import axios from 'axios';
import { Message, MessageBox } from 'element-ui'
import store from '@/store'
import { getToken, removeToken } from '@/utils/auth'
import router from '@/router'


export class baseApi {
	axios;
	router="";
	method="get";
	responseType="json";
	run(param){
		param=this.runConversion(param);
		this.axios = axios.create({
			withCredentials:true,
			baseURL: process.env.BASE_API,
			headers:{
				'X-Requested-With': 'XMLHttpRequest',
				'Content-Type':'application/json',
				"token":getToken(),
			},
			validateStatus: function(status) {
				return status == 200;
			},
			responseType: this.responseType,
			maxContentLength:200000,
		});
		let response;
		switch(this.method){
			case "get":
				return this.axios.get(this.router,{params:param}).then(response=>{
					let data=this.conversion(response.data)
					this.beforSuccess(data)
					this.successHandel(data);
				}).catch(error=>{
					if(error.response){
						this.errorHandel(error.response.status,error.response.data)
					}else{
						throw error;
					}
				})
			break;
			case "post":
				return this.axios.post(this.router,param).then(response=>{
					let data=this.conversion(response.data)
					this.beforSuccess(data)
					this.successHandel(data);
				}).catch(error=>{
					if(error.response){
						this.errorHandel(error.response.status,error.response.data)
					}else{
						throw error;
					}
				})
			break;
			case "delete":
				return this.axios.delete(this.router,{params:param}).then(response=>{
					let data=this.conversion(response.data)
					this.beforSuccess(data)
					this.successHandel(data);
				}).catch(error=>{
					if(error.response){
						this.errorHandel(error.response.status,error.response.data)
					}else{
						throw error;
					}
					
				})
			break;
		}
	}

	setError(status,fun){
		switch (status) {
			case 401:
			this.error401=fun;
			break;
			break;
			case 400:
			this.error400=fun;
			break;
			case 500:
			this.error500=fun;
			break;
			case 404:
			this.error404=fun;
			break;
		}
		return this;
	}



	error401(response) { //处理登录异常
		MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
			confirmButtonText: '重新登录',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(() => {
			removeToken()
			router.replace('/login')
		})
	};
	error400(response) { //400错误
		Message({
			message: response.message,
			type: 'error',
			duration: 3 * 1000
		})
	};
	error404(response) { //400错误
		Message({
			message: response.message,
			type: 'error',
			duration: 3 * 1000
		})
	};
	error500(response) { //500错误
		Message({
			message: "服务器维护中",
			type: 'error',
			duration: 3 * 1000
		})
	};
	afterError(response){
	};
	beforSuccess(response){
	};
	runConversion(param){
		return param;
	}
	conversion(response){
		return response;
	}
	success(fun){
		this.successHandel=fun;
		return this;
	}
	successHandel(response){

	}

	error(fun){
		this.errorCommon=fun;
		return this;
	}
	errorCommon(status,response){

	}
	errorHandel(status, response) {
		this.errorCommon(status, response);
		switch (status) {
			case 401:
			this.error401(response);
			break;
			case 400:
			this.error400(response);
			break;
			case 500:
			this.error500(response);
			break;
			case 404:
			this.error404(response);
			break;
			default:
			//网络断开
			break
		}
		this.afterError(response)
	};
}


// WEBPACK FOOTER //
// ./src/api/base.js